
import { defineComponent, inject, ref } from 'vue'

import sCompetition from '@/components/wizard/steps/StepCompetition.vue';

export default defineComponent({
    name: "modal-test",
    components: {sCompetition}, 
    setup() {
        const titleModal = ref<any>('')
        const rowAcrd = inject<any>('rowAcrd')
        const gblDialogTest = inject<any>('gblDialogTest')

        const onOpen = () => {
            titleModal.value = rowAcrd.value.firstname + " " +   rowAcrd.value.lastname
        }

        const onClosed = () => {
            rowAcrd.value = {}
        }

        return {
            titleModal,
            rowAcrd,
            gblDialogTest,
            onClosed,
            onOpen
        }
        
    },
})
